import { AxiosInstancePlus } from '@tencent/oneid-request';
import { APP_TYPE } from 'common/constants/Constants';
import { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';

export interface IAppsConfig {
  /** 应用类型 */
  app_type?: APP_TYPE;
  /** 应用名称 */
  app_name?: string;
  /** 应用logo */
  logo_uri?: string;
  /** 带文字的logo */
  logo_with_text_uri?: string;
  /** 服务条款 */
  tos_uri?: string;
  /** 隐私政策 */
  policy_uri?: string;
  /** 应用背景图 */
  background_uri?: string;
  /** 应用协议模板 */
  agreement_template?: string;
  /** 个人退出企业文案 */
  personal_off_tips?: string;
  /** 企业注销文案 */
  account_off_tips?: string;
  /** 企业拒绝注销文案 */
  account_reject_off_tips?: string;
  /** 隐藏应用logo */
  hidden_logo?: boolean;
  /** 隐藏登录页底部描述 */
  hidden_bottom_desc?: boolean;
  /** 隐藏登录页底部提示 */
  hidden_tip?: boolean;
  /** 禁用登录即注册场景（新手机号登录时，验证手机号完成后跳转注册页面） */
  disable_login_register?: boolean;
  /** 是否为没有接入登录的单应用 */
  is_single_without_idp?: boolean;
  /** 没接入登录时的跳转链接 */
  app_portal_uri?: string;
  /** 回跳应用的引导注册地址 */
  register_uri?: string;
}

class AppsApi {
  public axiosInstance: AxiosInstancePlus = http;

  public prefixURL = '/admin/bff';

  /**
   * 获取应用信息
   * @param appTypes 应用类型，多个用,分割
   */
  async getAppsInfo(appTypes: string[]): Promise<IResponseType<Record<string, IAppsConfig>>> {
    return this.axiosInstance.get(`${this.prefixURL}/config/apps`, {
      params: { app_types: appTypes.join(',') },
      skipShowError: true,
    });
  }
}
export default new AppsApi();
